/**
 * What a registered computer is, in the words the UI uses for it.
 *
 * Two kinds exist. A cabinet computer (`device_type === 'medication_cabinet'`)
 * runs one physical medication cabinet; the cabinet's name rides on the device
 * as `cabinet_embed`, so naming it costs no request. Anything else is a kiosk:
 * a charting computer, optionally tied to one activity (`activity_embed`).
 * Older records carry `device_type` null or the "patient_chart" the Sim
 * Control Panel used to write; both are kiosks.
 */
export const CABINET_COMPUTER = 'medication_cabinet'

export function isCabinetComputer (device) {
  return !!device && device.device_type === CABINET_COMPUTER
}

export function deviceKindLabel (device) {
  if (!device) return ''
  if (isCabinetComputer(device)) {
    const cabinet = device.cabinet_embed && device.cabinet_embed.name
    return cabinet ? `Cabinet · ${cabinet}` : 'Cabinet Device'
  }
  const activity = device.activity_embed && device.activity_embed.activity_name
  return activity ? `Kiosk · ${activity}` : 'Kiosk'
}
